<app-header [sportId]="sportId" [sportName]="sportName" [date]="date"></app-header>

<main role="main">
    <router-outlet></router-outlet>
</main>

<app-footer [sportName]="sportName"></app-footer>
<app-player-match-stats [sportName]="sportName" [sportId]="sportId"></app-player-match-stats>
